import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as ArrowIcon } from "assets/icons/arrow-up-s-line.svg";
import CheckedComponent from "components/CheckedComponent";

// Core features available with all plans (from Figma design)
const CORE_FEATURES = [
  "JS Rendering",
  "Premium Proxies",
  "JSON Auto Parsing",
  "Rotating Proxy Pools",
  "Custom Header Support",
  "CAPTCHA & Anti-Bot Detection",
  "Custom Session Support",
  "Desktop & Mobile User Agents",
  "Automatic Retries",
  "Unlimited Bandwidth",
  "99.9% Uptime Guarantee",
  "Best-in-class Support",
];

export default function CoreFeaturesSection() {
  const isWideScreen = useMediaQuery({ query: "(min-width: 1440px)" });

  return (
    <div className="py-6">
      <Disclosure defaultOpen={isWideScreen}>
        {({ open }) => (
          <div
            className={`border border-neutral-200 dark:border-neutral-700 rounded px-6 flex flex-col items-center ${
              open ? "pt-4 pb-6 gap-6" : "py-4"
            }`}
          >
            <DisclosureButton
              className={`w-full flex items-center justify-center gap-2 font-droid text-base leading-none uppercase font-normal text-gray-900 dark:text-white ${
                isWideScreen ? "cursor-default" : "cursor-pointer"
              }`}
              disabled={isWideScreen}
            >
              Scraperapi core features - available with all plans
              {!isWideScreen && (
                <ArrowIcon
                  className={`w-6 h-6 [&_path]:fill-current transition-transform ${open ? "" : "rotate-180"}`}
                />
              )}
            </DisclosureButton>
            <DisclosurePanel static={isWideScreen} className="w-full">
              <div className="grid grid-flow-col grid-cols-1 grid-rows-12 md:grid-cols-2 md:grid-rows-6 lg:grid-cols-3 lg:grid-rows-4 gap-x-[4.5rem] gap-y-4">
                {CORE_FEATURES.map((feature) => (
                  <CheckedComponent
                    key={feature}
                    variant="outline"
                    className="text-sm text-gray-900 dark:text-white"
                  >
                    {feature}
                  </CheckedComponent>
                ))}
              </div>
            </DisclosurePanel>
          </div>
        )}
      </Disclosure>
    </div>
  );
}
